import Promise from 'bluebird';
import {DOC_TYPE} from './const';
// import moment from 'moment';
var dateFormat = require('dateformat');

function clone(a){
    return JSON.parse(JSON.stringify(a));
}
function getRandomString(length,sourceString){
    var s = "";
    length = length || 16;
    sourceString = sourceString || "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (var i = 0; i < length; i++ ) {
        s += sourceString.split('')[Math.floor(Math.random() * sourceString.length)];
    }
    return s;
}

function timeout(time) {
    return new Promise(function (resolve) {
        setTimeout(resolve,time)
    })
}

function daysBetween(d1,d2) {
    if(!d1 || !d2) return null;
    var msPerDay = 86400000;
    var offset = (new Date().getTimezoneOffset() / -60) * 3600*1000;
    var d1 = (d1 + offset) /msPerDay;
    var d2 = (d2 + offset) /msPerDay;
    var s1 = parseInt(d1);
    var s2 = parseInt(d2);
    return s2 - s1 ;
}

function docTypeDisplay(type) {
    return DOC_TYPE[type.toUpperCase()];
}

function timeDisplay(timestamp,format) {
    format = format || "yyyy-mm-dd";
    // return moment(new Date(timestamp)).format(format);
    return dateFormat(new Date(timestamp),format);
}
function timeDisplayWithWeekDayAndHour(timestamp) {
    var d = new Date(timestamp);
    var prefix = dateFormat(d,'yyyy-mm-dd');
    var suffix = dateFormat(d,'HH:MM');
    return `${prefix} ${weekDayDisplay(timestamp)} ${suffix}`
}

function weekDayDisplay(timestamp){
    var weekDay = ['周日','周一','周二','周三','周四','周五','周六'];
    return weekDay[new Date(timestamp).getDay()]||'';
}

function timeISODisplay(dateObject){
    return dateFormat(new Date( +dateObject+2*(dateObject.getTimezoneOffset()/60)*3600000   ),"yyyy-mm-dd'T'HH:MM:ss.000'Z'");
}

function timeAgeDisplay(fromDateObj,toDateObj){
    var diffDays = (toDateObj - fromDateObj)/(86400 * 1000);
    var daysPerYear = 365;
    var daysPerMonth = daysPerYear/12;

    if(diffDays > daysPerYear){
        var diffYear = Math.round((diffDays/daysPerYear) * 2) / 2;
        if(diffYear.toString().indexOf('.5')!==-1){ // half
            return Math.floor(diffYear)+"年半";
        }else{
            return Math.floor(diffYear)+"年";
        }
    }else{
        return Math.round(diffDays/daysPerMonth)+'个月';
    }
}

function object2Options(obj,defaultOption={value:0,label:'请选择'}) {
    var arr = defaultOption ? [defaultOption] : [];
    for(var k in obj){
        arr.push({
            label:obj[k],
            value:k
        });
    }
    return arr;
}

function getDayZeroClockTimestamp(tm) {
    var d = new Date(tm);
    var d2 = new Date(d.getFullYear(),d.getMonth(),d.getDate());
    return +d2;
}


var userAgent = navigator.userAgent || navigator.vendor || window.opera;
module.exports = {
    clone,
    object2Options,
    getRandomString,
    timeout,
    timeISODisplay,
    daysBetween,
    timeDisplay,
    timeDisplayWithWeekDayAndHour,
    weekDayDisplay,
    getDayZeroClockTimestamp,
    docTypeDisplay,
    timeAgeDisplay,
    go:function () {
        return $router.go.apply($router,arguments);
    },
    log:function () {
        console.log.apply(console,arguments);
    },
    isIOS:function () {
        return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    },
    isAndroid:function () {
        return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;;
    },
    isReliao:function () {
        return userAgent.indexOf('Reliao') > -1;
    }
};


// WEBPACK FOOTER //
// src/lib/util.js